import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function ParametrosAgenda() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    let userdata = [];
    let clientData = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log('err: '+error);
            });
    },[]);

    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div class="col-sm-8">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li class="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                        <li class="breadcrumb-item">Parámetros De Agenda</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Parámetros De Agenda</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section class="content" >
                        <div class="container-fluid">

                            
                            <div class="row">
                                <div class="col-md-12 btn-settings-container">
                                  <Link to="/crear-agendas" class="btn-settings">
                                  Crear Agendas
                                  </Link>
  
                                    <Link to="/estados-cita" class="btn-settings">
                                    Estados De Las Citas
                                    </Link>

                                    <Link to="/bloqueos-agenda" class="btn-settings">
                                    Bloqueo De Horarios
                                    </Link>

                                    <Link to="/unidades-atencion" class="btn-settings">
                                    Unidades De Atención
                                    </Link>

                                    <Link to="/bloqueos-unidades" class="btn-settings">
                                    Bloqueos de Unidades De Atencion
                                    </Link>


                                </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default ParametrosAgenda;